var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotInvested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0007,
    cy: 10.0007,
    r: 6.66667,
    fill: "#1177BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4993 36.6667C24.7495 36.6667 23.3746 36.6667 22.5203 35.8124C21.666 34.9581 21.666 33.5832 21.666 30.8333C21.666 28.0835 21.666 26.7085 22.5203 25.8543C23.3746 25 24.7495 25 27.4993 25C30.2492 25 31.6241 25 32.4784 25.8543C33.3327 26.7085 33.3327 28.0835 33.3327 30.8333C33.3327 33.5832 33.3327 34.9581 32.4784 35.8124C31.6241 36.6667 30.2492 36.6667 27.4993 36.6667ZM25.5942 27.5533C25.2145 27.1736 24.599 27.1736 24.2193 27.5533C23.8396 27.933 23.8396 28.5485 24.2193 28.9282L26.1244 30.8333L24.2193 32.7385C23.8396 33.1181 23.8396 33.7337 24.2193 34.1134C24.599 34.4931 25.2145 34.4931 25.5942 34.1134L27.4993 32.2083L29.4045 34.1134C29.7842 34.4931 30.3997 34.4931 30.7794 34.1134C31.1591 33.7337 31.1591 33.1181 30.7794 32.7385L28.8743 30.8333L30.7794 28.9282C31.1591 28.5485 31.1591 27.933 30.7794 27.5533C30.3997 27.1736 29.7842 27.1736 29.4045 27.5533L27.4993 29.4584L25.5942 27.5533Z",
    fill: "#1177BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1586 25.0513C29.4505 24.9994 28.5819 24.9993 27.5007 24.9993C24.7508 24.9993 23.3759 24.9993 22.5216 25.8536C21.6673 26.7079 21.6673 28.0828 21.6673 30.8327C21.6673 32.7765 21.6673 34.0333 21.9691 34.9049C21.3292 34.967 20.6715 34.9993 20.0007 34.9993C13.5573 34.9993 8.33398 32.0146 8.33398 28.3327C8.33398 24.6508 13.5573 21.666 20.0007 21.666C24.3564 21.666 28.1546 23.03 30.1586 25.0513Z",
    fill: "#84DCC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInvested);
export default __webpack_public_path__ + "static/media/not-invested.3e7d19c8c736801de4b692f68b553a69.svg";
export { ForwardRef as ReactComponent };